const locales = {
  en: {
    name: 'English',
    code: 'en'
  },
  fr: {
    name: 'Français',
    code: 'fr'
  }
}

/* Single source of truth for which locales the portal supports. This module has
   no imports of its own, so it is safe to pull into stores, guards and services
   without the initialisation-order problems that made these lists get inlined. */
export const supportedLocales = Object.keys(locales)

export const fallbackLocale = 'en'

export const isSupportedLocale = locale => supportedLocales.includes(locale)

/* Falls back to `fallbackLocale` for anything unsupported - e.g. a browser
   reporting `de`, which would otherwise route to a non-existent /de/ prefix. */
export const resolveLocale = locale => (isSupportedLocale(locale) ? locale : fallbackLocale)

export default locales
